import axios from 'axios';
import { createSignedPostRequest } from 'utils/createSignedRequestsHelpers';

export default async function deleteResource(resource) {
  const apiPath = `resources/delete-resource`;

  const signedRequest = await createSignedPostRequest({
    apiPath,
    body: resource,
  });

  const response = await axios(signedRequest);

  return response.data;
}
